import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import './CellHoverButton.css';

interface CellHoverButtonProps {
  onEnrich: () => void;
  isVisible: boolean;
}

const CellHoverButton: React.FC<CellHoverButtonProps> = ({ onEnrich, isVisible }) => {
  if (!isVisible) return null;

  return (
    <button
      className="cell-hover-button"
      onClick={(e) => {
        e.stopPropagation();
        onEnrich();
      }}
      title="Enrich this cell"
    >
      <PlayArrowIcon style={{ fontSize: '14px' }} />
    </button>
  );
};

export default CellHoverButton; 